// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require(44);

$export($export.P, 'Set', {toJSON: require(37)('Set')});